import { storage, tokenName } from '@/config'
import Cookies from 'js-cookie'

export function getAccessToken()
{
    if(storage === 'localStorage'){
        return localStorage.getItem(tokenName)
    }else if(storage === 'sessionStorage'){
        return sessionStorage.getItem(tokenName)
    }else{
        return Cookies.get(tokenName)
    }
}

export function setAccessToken(accessToken)
{
    if(storage === 'localStorage'){
        return localStorage.setItem(tokenName, accessToken)
    }else if(storage === 'sessionStorage'){
        return sessionStorage.setItem(tokenName, accessToken)
    }else{
        return Cookies.set(tokenName, accessToken, { expires: 7, path: '/'  })
    }
}

export function removeAccessToken()
{
    if(storage === 'localStorage'){
        return localStorage.removeItem(tokenName)
    }else if(storage === 'sessionStorage'){
        return sessionStorage.removeItem(tokenName)
    }else{
        return Cookies.remove(tokenName)
    }
}
